import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Answer, Question } from '@haleo-frontend/data-access/models';

@Component({
    selector: 'app-thought-record-question-text',
    templateUrl: 'text.component.html',
    styleUrls: ['text.component.scss']
})
export class TextComponent implements OnChanges {

    @Input() question: Question;
    @Input() answer: Answer | undefined;
    @Output() answered: EventEmitter<any>;

    value: string;
    placeHolder: string;

    constructor() {
        this.answered = new EventEmitter<any>();
        this.value = '';
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (this.value && this.value !== '') {
            this.value = '';
        }

        if (this.question) {

            this.placeHolder = '';
            if (this.question.options && this.question.options.length > 0) {

                const data = JSON.parse(this.question.options);
                if (data && data.placeHolder) {
                    this.placeHolder = data.placeHolder;
                }
            }
        }

        if (this.answer && this.answer.value) {
            this.value = this.answer.value;
        }
    }

    continue() {

        if (this.value.length > 0) {
            this.answered.emit(this.value);
        }
    }
}
